<template>
<div class="componentWrapper">
    <div class="descriptionMain">
        <div class="column">
            <div class="title">
                <p>{{$t('listingPage.title')}}</p>
            </div>
            <p 
                class="descriptionText" 
                v-html="fetchDataListing.description"
            ></p>
        </div>
        <div class="column" id="columnMobile">
            <div class="title">
                <p>{{$t('listingPage.mobileTitle')}}</p>
            </div>
            <p>
                <b>{{$t('listingPage.price')}}:</b> {{ fetchDataListing.price }}€ 
                <span v-if="!shopData.legalEntity.taxNr" style="color: rgb(180,180,180)">({{ $t('listingPage.noTax') }})</span>
                <span v-else style="color: rgb(180,180,180)">({{ $t('listingPage.tax') }})</span>
            </p>
            <p><b>{{$t('listingPage.stock')}}:</b> {{ fetchDataListing.availableQuantity }} tk</p>
            <p><b>{{$t('listingPage.deliveryTime')}}:</b> {{ fetchDataListing.deliveryTime }} päeva</p>
        </div>
        <!-- <div class="column" v-if="fetchDataListing.sku">
            <div class="title">
                <p>{{$t('listingPage.sku')}}</p>
            </div>
            <div class="line"></div>
            <p class="productSku" id="product-code"><b>Tootekood</b> - {{ fetchDataListing.sku }}</p>
        </div> -->
    </div>
 </div>
</template>

<script>

export default {
  name: 'listingDescription',
  components: {
  },
   props: {
    fetchDataListing: {
        required: true
    },
    shopData: {
        required: true
    },
  },
    data() {
        return {
        }
    },

    methods: {
    },
}
</script>

<style scoped>
.componentWrapper {
    width: 100%;
    margin-top: 25px;
    position: relative;
    padding-bottom: 0px;
}
.descriptionMain {
    position: relative;
    overflow: hidden;
}
.column {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
}
.column:last-child {
    border: none;
}
#columnMobile {
    display: none;
}
.line {
    height: 1px;
    width: 100%;
    border-top: 1px solid rgb(230,230,230);
    margin-bottom: 10px;
}
.title p {
    width: 100%;
    margin-top: 35px;
    margin-bottom: 10px;
    text-align: left;
    color: rgb(150, 150, 150);
    font-size: 24px;
    font-family: 'Nunito', sans-serif;
    font-weight: 700;
}
.title p:first-child {
    margin-top: 0px;
}
.descriptionText {
    width: 100%;
    margin: 0;
    margin-top: 0px;
    margin-bottom: 25px;
    font-size: 18px;
    word-wrap: break-word;
    color: #212529;
    font-family: 'Nunito', sans-serif;
    font-size: 16px;
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 500;
  
}
.table {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 35px;
}
.table p {
    border-bottom: 1px solid #d9e1e8;
    padding-bottom: 5px;
    margin: 0;
    margin-top: 5px;
    color: #555d6c;
}
.right p {
  padding-left: 200px;
  padding-right: 130px;
}
.labels {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 25px;
}
.labels img {
    width: 8%;
    margin-right: 35px;
}
.productSku {
    color: rgb(50,50,50);
    font-size: 1rem;
    word-wrap: break-word;
    color: rgb(75, 75, 75);
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
}
/* @media only screen and (max-width: 1150px) {
    .componentWrapper {
        width: 500px;
    }
    .singleMethod {
        width: 295px;
    }
}
@media only screen and (max-width: 830px) {
    .componentWrapper {
        width: 395px;
        padding-left: 15px;
    }
}
@media only screen and (max-width: 750px) {
    .componentWrapper {
        width: 100%;
        margin: 0 auto;
        margin-top: 25px;
        padding: 0;
        padding-left: 0px;
    }
    .line {
        display: inherit;
        height: 1px;
        width: 100%;
        border-top: 1px solid rgb(230,230,230);
        margin-bottom: 10px;
    }
    .column {
        border: none;
    }
    .descriptionText {
        width: 100%;
    }
    #columnMobile {
        display:block;
        padding-top: 25px;
        padding-bottom: 25px;
    }
}

@media only screen and (max-width: 430px) {
    
    .column:last-child {
        border: none;
    }
} */
</style>
